import { createAction, props } from "@ngrx/store";
import { Offer } from "../../models/offer";

//export const loadOfferAct = createAction('loadOfferEffect', props<{ page: number, pageSize: number}>());

//export const findAllPageableOfferAct = createAction('findAllPageableOfferEffect', props<{ offers: Offer[], paginator: any }>());

//export const findOffer = createAction('findOffer', props<{ id: number}>());
export const findOfferAct = createAction('findOfferEffect', props <{ id: number }>());
export const loadOfferByIdAct = createAction('loadOfferByIdEffect', props<{ offer: Offer }>());

export const resetOfferAct = createAction('resetOffer');
export const updateOfferAct = createAction('updateOfferEffect', props<{ offerUpdated: Offer }>());
export const updateSuccessOfferAct = createAction('updateSuccessOfferEffect', props<{ offerUpdated: Offer }>());

export const saveOfferAct = createAction('saveOfferEffect', props<{ offerNew: Offer }>());
export const saveSuccessOfferAct = createAction('saveSuccessOfferEffect', props<{ offerNew: Offer }>());

export const setViolationsOfferAct = createAction('setViolationsOfferEffect', props<{ offerForm: Offer, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );

//recalculateOfferAct
export const recalculateOfferAct = createAction('recalculateOfferEffect', props<{ offerRecalculate: Offer }>());
export const recalculateSuccessOfferAct = createAction('recalculateSuccessOfferEffect', props<{ offerRecalculate: Offer }>());

// Optener Firmas
export const getSignaturesOfferAct = createAction('getSignaturesOfferEffect', props<{ offerSignature: Offer }>());
export const getSignaturesSuccessOfferAct = createAction('getSignaturesSuccessOfferEffect', props<{ offerSignature: Offer }>());

// Proceso de Firmas
export const sendSignaturesOfferAct = createAction('sendSignaturesOfferEffect', props<{ offerSignature: Offer }>());
export const sendSignaturesSuccessOfferAct = createAction('sentSignaturesSuccessOfferEffect', props<{ offerSendSignature: Offer }>());

// Operar Oferta
export const sendOperateOfferAct = createAction('sendOperateOfferEffect', props<{ offerOperate: Offer }>());
export const sendOperateSuccessOfferAct = createAction('sentOperateSuccessOfferEffect', props<{ offerOperate: Offer }>());

// Eliminar Oferta
export const deleteOfferAct = createAction('deleteOfferEffect', props<{ offerId: number }>());
export const deleteSuccessOfferAct = createAction('deleteOfferSuccessEffect', props<{ offerId: number }>());